import React, {createContext, useContext, useState} from 'react';
import AuthService from "../services/AuthService";
import {PMSPharmacyContext} from "./pms_contexts/PMSPharmacyContext";
import * as AppType from "../helpers/AppType";
import {PMSConfigContext} from "./pms_contexts/PMSConfigContextProvider";
import {FIREBASE_TOKEN, MAX_DEVICES, PMS_SALE_DISCOUNT, PMS_TEMP_USER, ROLE_TYPE} from "../helpers/Constants";
import Notification from "../components/common/Notification";
import {generateLocalStorageKey, getErrorMessage} from "../helpers/Utils";

import cookie from "js-cookie";

import {signInWithPhoneNumber} from "firebase/auth";
import {socialAuth} from "../helpers/firebase";

export const AuthContext = createContext("AuthContext");

const auth = localStorage.getItem("oushodsheba_access_token");
const roleType = localStorage.getItem(ROLE_TYPE);
let permissions_ = localStorage.getItem("oushodsheba_permissions");
let appType_ = localStorage.getItem("appType");
permissions_ = permissions_ ? JSON.parse(permissions_) : [];

const AuthContextProvider = ({children}) => {

    const pmsPharmacyContext = useContext(PMSPharmacyContext);
    const pmsConfigContext = useContext(PMSConfigContext);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [isLogin, setIsLogin] = useState(!!auth);
    const [permissions, setPermissions] = useState([...permissions_, 'ALL']);
    const [appType, setAppType] = useState(appType_);


    const [isAffiliator, setIsAffiliator] = useState(!!roleType);

    const [verifyOtpLoading, setVerifyOtpLoading] = useState(false);
    const [validatePhoneLoading, setValidatePhoneLoading] = useState(false);

    const {setUsers} = useContext(AuthContext);

    const loginRequest = async (data, isPharmacist = false, adminLogin = false) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await AuthService.login(data, isPharmacist);
            localStorage.setItem("oushodsheba_access_token", res.data.token.access);
            let moduleBasePermissions = res.data.moduleBasePermissions;

            if (adminLogin) {
                setAppType(AppType.OS);
                localStorage.setItem("appType", AppType.OS);
            } else {
                setAppType(AppType.PMS);
                localStorage.setItem("appType", AppType.PMS);
            }

            if (isPharmacist) {

                localStorage.setItem(MAX_DEVICES, res.data?.liteUserDTO?.maxDevices);

                localStorage.setItem("selectedPharmacy", JSON.stringify(res.data.liteUserDTO.pharmacy));
                pmsPharmacyContext.setSelectedPharmacy(res.data.liteUserDTO.pharmacy);
                pmsConfigContext.getPMSPrintingConfigByPharmacyId(res.data.liteUserDTO.pharmacy.id);
            }

            let permissionList = [];

            for (let e in moduleBasePermissions) {
                permissionList.push(e);
                moduleBasePermissions[e].forEach(p => {
                    permissionList.push(p.name);
                });
            }

            setPermissions(permissionList);
            localStorage.setItem("oushodsheba_permissions", JSON.stringify(permissionList));

            setIsLogin(true);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            const message = error.response ? error.response.data.message : error.message
            setErrorMsg(message);
            return false;
        }

    }

    const loginAdminRequest = async (data) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await AuthService.adminLogin(data);
            localStorage.setItem("oushodsheba_access_token", res.data.token.access);
            let moduleBasePermissions = res.data.moduleBasePermissions;

            setAppType(AppType.OS);
            localStorage.setItem("appType", AppType.OS);

            let permissionList = [];

            for (let e in moduleBasePermissions) {
                permissionList.push(e);
                moduleBasePermissions[e].forEach(p => {
                    permissionList.push(p.name);
                });
            }

            setPermissions(permissionList);
            localStorage.setItem("oushodsheba_permissions", JSON.stringify(permissionList));

            setIsLogin(true);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            const message = error.response ? error.response.data.message : error.message
            setErrorMsg(message);
            return false;
        }

    }

    const logoutRequest = async () => {


        await pmsPharmacyContext.removeSession();

        setIsLogin(false);

        // localStorage.removeItem(generateLocalStorageKey("sale"));

        localStorage.removeItem(MAX_DEVICES);

        localStorage.removeItem(ROLE_TYPE);
        localStorage.removeItem("selectedPharmacy");
        localStorage.removeItem("oushodsheba_access_token");
        localStorage.removeItem("oushodsheba_permissions");
        localStorage.removeItem("appType");
        localStorage.removeItem("printing_config");
        localStorage.removeItem(PMS_SALE_DISCOUNT);
        // localStorage.removeItem(AFFILIATE_LOGIN);
        pmsPharmacyContext.setSelectedPharmacy(null);
        // localStorage.clear();
    }


    const affiliateLoginRequest = async (data, isPharmacist = false, adminLogin = false) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await AuthService.affiliatelogin(data, isPharmacist);
            localStorage.setItem("oushodsheba_access_token", res.data.token.access);
            let moduleBasePermissions = res.data.moduleBasePermissions;

            let permissionList = [];

            for (let e in moduleBasePermissions) {
                permissionList.push(e);
                moduleBasePermissions[e].forEach(p => {
                    permissionList.push(p.name);
                });
            }

            setPermissions(permissionList);
            localStorage.setItem("oushodsheba_permissions", JSON.stringify(permissionList));
            localStorage.setItem(ROLE_TYPE, "Affiliator");

            setIsAffiliator(true);

            setIsLogin(true);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            const message = error.response ? error.response.data.message : error.message
            setErrorMsg(message);
            return false;
        }

    }

    const getFirebaseOtp = async data => {
        try {

            setValidatePhoneLoading(true);

            data = {
                ...data,
                otpValidTime: Date.now()
            }

            let appVerifier = window.recaptchaVerifier;
            window.confirmationResult = await signInWithPhoneNumber(socialAuth, data?.primaryPhone, appVerifier);
            cookie.set(PMS_TEMP_USER, JSON.stringify(data));

            Notification("success", "Send OTP", "Send OTP to phone");

            setValidatePhoneLoading(false);

            return true;

        } catch (error) {
            setValidatePhoneLoading(false);
            const message = getErrorMessage(error);
            Notification("error", "ERROR", `${error}`);

            return false;
        }
    }

    const verifyOtp = async data => {
        try {

            setVerifyOtpLoading(true);

            let confirmationResult = window.confirmationResult;


            if (!confirmationResult) {
                Notification("success", "ERROR", "Session Expired");

                setVerifyOtpLoading(false);
                return;
            }

            const firebaseResponse = await confirmationResult.confirm(data.code);

            let _data = cookie.get(PMS_TEMP_USER);

            _data = _data ? JSON.parse(_data) : null;
            cookie.set(FIREBASE_TOKEN, JSON.stringify(firebaseResponse.user.accessToken));

            // const res = await AuthService.signUpByMobile(_data, firebaseResponse.user.accessToken);

            // cookie.set(ACCESS_TOKEN, res.data.token.access);
            // cookie.remove(PMS_TEMP_USER);

            // setUsers(res.data.user);

            Notification("success", "sign up", "Successfully sign up");


            setVerifyOtpLoading(false);

            return true;

        } catch (error) {
            setVerifyOtpLoading(false);
            const message = getErrorMessage(error);
            Notification("error", "ERROR", `${error}`);
            return false;
        }
    }

    return (
        <AuthContext.Provider
            value={{
                loading,
                errorMsg,
                isLogin,
                appType,
                loginRequest,
                logoutRequest,
                loginAdminRequest,
                permissions,
                affiliateLoginRequest,
                isAffiliator,
                verifyOtp,
                getFirebaseOtp,
                verifyOtpLoading,
                validatePhoneLoading
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContextProvider;